import { Button, Dialog, DialogContent } from '@commenda/kakashi';

type CancelEnvelopeConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  documentName: string;
  recipientName: string;
  allRecipientNames: string[];
  onConfirm: () => void | Promise<void>;
  isCancelling?: boolean;
};

export const CancelEnvelopeConfirmationModal = ({
  isOpen,
  onClose,
  documentName,
  recipientName,
  allRecipientNames,
  onConfirm,
  isCancelling = false,
}: CancelEnvelopeConfirmationModalProps) => {
  const count = allRecipientNames.length;
  const doc = documentName || 'document';

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="p-6 flex flex-col gap-4 max-w-md">
        <div>
          <h3 className="txt-lg-bold text-text-primary mb-2">
            Cancel signature request
          </h3>
          <p className="txt-small-regular text-text-secondary mb-3">
            This will cancel the signature request for{' '}
            <strong>
              all {count} recipient{count !== 1 ? 's' : ''}
            </strong>{' '}
            on {doc}, not just {recipientName}. This action cannot be undone.
          </p>
          {allRecipientNames.length > 0 && (
            <ul className="list-disc list-inside txt-small-regular text-text-secondary space-y-0.5">
              {allRecipientNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          )}
        </div>
        <div className="flex justify-end gap-2 items-center mt-2">
          <Button
            variant="secondary"
            size="md"
            onClick={onClose}
            disabled={isCancelling}
          >
            Keep Request
          </Button>
          <Button
            variant="destructive-secondary"
            size="md"
            onClick={async () => {
              await onConfirm();
              onClose();
            }}
            disabled={isCancelling}
          >
            {isCancelling ? 'Cancelling...' : 'Cancel for All'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
